import { makeAutoObservable } from 'mobx'
import { formSubmissionApi } from '@/api/formSubmission'
import { addAxiosErrorNotification } from '@/components'
import { AvailableFormType, EmployeStatuses, FormSubmissionRequest, FormSubmissionResponse } from '@/types'

class FormSubmissionStore {
  availableFormSubmission: AvailableFormType | null = null
  formSubmissionQuestions: FormSubmissionResponse | null = null
  isShowCustomAnswerInput = false
  userCustomLanguage = ''
  employedStatus: EmployeStatuses | null = null
  isShowSubmissionFinishModal = false
  isShowSubmissionStartModal = false

  constructor() {
    makeAutoObservable(this)
  }

  setShowSubmissionFinishModal = (value: boolean) => {
    this.isShowSubmissionFinishModal = value
  }

  setShowSubmissionStartModal = (value: boolean) => {
    this.isShowSubmissionStartModal = value
  }

  setIsShowCustomAnswerInput = (value: boolean) => {
    this.isShowCustomAnswerInput = value
  }

  setUserCustomLanguage = (value: string) => {
    this.userCustomLanguage = value
  }

  setEmployedStatus = (value: EmployeStatuses | null) => {
    this.employedStatus = value
  }

  setAvailableFormSubmission = (params: AvailableFormType | null) => {
    this.availableFormSubmission = params
  }

  setFormSubmissionQuestions = (params: FormSubmissionResponse) => {
    this.formSubmissionQuestions = params
  }

  getAvailableFormSubmission = () =>
    formSubmissionApi
      .checkFormSubmission()
      .then((response) => {
        if (response.success && response.data) {
          this.setAvailableFormSubmission(response.data)
        }

        return response
      })
      .catch(addAxiosErrorNotification)

  getFormSubmissionAnswers = (params: FormSubmissionRequest) =>
    formSubmissionApi
      .getFormSubmissionQuestions(params)
      .then((response) => {
        if (response.success && response.data) {
          this.setFormSubmissionQuestions(response.data)
        }

        return response
      })
      .catch(addAxiosErrorNotification)

  reset = () => {
    this.availableFormSubmission = null
    this.isShowCustomAnswerInput = false
    this.userCustomLanguage = ''
    this.employedStatus = null
    this.isShowSubmissionFinishModal = false
    this.isShowSubmissionStartModal = false
  }
}

export const formSubmissionStore = new FormSubmissionStore()
